<ng-template #addForm>
  <va-filter-container [showToolbar]="true" (searchTermChanged)="term$.next($event)">
    <div content>
      <div *ngFor="let user of users$ | async; let last = last">
        <app-list-item
          [titleText]="user.fullName"
          [subtitleText]="user.email"
          [clickable]="false"
          [style.border-top]="'1px solid #DADADA'"
          [style.border-bottom]="last ? '1px solid #DADADA' : 'none'"
        >
          <!-- TODO: brandView should be a separate template; the checkbox could be used for it as well -->
          <mat-checkbox
            *ngIf="!brandView"
            secondary-action-item
            [checked]="isUserExists(user)"
            [disabled]="isUserExists(user)"
            (change)="addUserToSelected($event, user)"
          ></mat-checkbox>
          <button
            *ngIf="brandView && !isLoading(user)"
            secondary-action-item
            mat-button
            [color]="isUserExists(user) ? 'accent' : 'primary'"
            (click)="addUserToBrand(user)"
          >
            <mat-icon *ngIf="isUserExists(user)">check</mat-icon>
            <ng-container *ngIf="!isUserExists(user)">
              <mat-icon>add</mat-icon>
            </ng-container>
          </button>
          <button
            *ngIf="brandView && isLoading(user)"
            secondary-action-item
            mat-button
            [color]="isUserExists(user) ? 'accent' : 'primary'"
            (click)="customAccess(user)"
          >
            <mat-spinner [diameter]="30"></mat-spinner>
          </button>
        </app-list-item>
      </div>
      <div
        *ngIf="loading$ | async"
        style="display: flex; align-items: center; justify-content: center; min-height: 61px"
      >
        <mat-spinner [diameter]="32" [strokeWidth]="4" [style.height.px]="32"></mat-spinner>
      </div>
      <div
        *ngIf="(users$ | async)?.length === 0 && (loading$ | async) === false"
        style="
          display: flex;
          align-items: center;
          justify-content: center;
          min-height: 61px;
          border-bottom: 1px solid #dadada;
        "
      >
        {{ 'ADD_USER_DIALOG.NONE_FOUND' | translate }}
      </div>
    </div>
  </va-filter-container>
  <div class="table-footer">
    <button
      mat-button
      *ngIf="userService.hasMoreResults | async"
      (click)="userService.loadMore()"
      style="height: inherit"
    >
      {{ 'COMMON.ACTION_LABELS.LOAD_MORE' | translate }}
    </button>
  </div>
</ng-template>

<mat-dialog-content>
  <h2 mat-dialog-title>
    <ng-container *ngIf="!brandView; else brandViewHeader">
      {{ 'ADD_USER_DIALOG.ADD_USERS_TO_ACCOUNT' | translate }}
    </ng-container>
    <ng-template #brandViewHeader>
      {{ 'ADD_USER_DIALOG.ADD_USER_TO_BRAND' | translate }}
    </ng-template>
  </h2>

  <div class="content">
    <ng-container *ngIf="showCreateTab; else addForm">
      <mat-tab-group (selectedTabChange)="tabChanged($event)">
        <mat-tab label="{{ 'ADD_USER_DIALOG.CREATE_USER' | translate }}">
          <div class="create-form-container">
            <app-create-user-form
              #createForm
              [accountGroupId]="accountGroupId"
              (userCreated)="userCreated($event)"
            ></app-create-user-form>
          </div>
        </mat-tab>
        <mat-tab label="{{ 'ADD_USER_DIALOG.ADD_EXISTING_USER' | translate }}">
          <div>
            <ng-container *ngTemplateOutlet="addForm"></ng-container>
          </div>
        </mat-tab>
      </mat-tab-group>
    </ng-container>
  </div>
</mat-dialog-content>

<ng-container *ngIf="!brandView; else brandViewActions">
  <mat-dialog-actions [ngClass]="{ 'tertiary-button': !showCreateTab }">
    <ng-container *ngIf="!showCreateTab">
      <div class="left-actions">
        <button mat-button color="primary" [disabled]="isLoading$ | async" (click)="dialogRef.close('create-new-user')">
          {{ 'ADD_USER_DIALOG.CREATE_USER' | translate }}
        </button>
      </div>
    </ng-container>

    <div class="right-actions">
      <button mat-stroked-button color="secondary" mat-dialog-close [disabled]="isLoading$ | async">
        {{ 'COMMON.ACTION_LABELS.CLOSE' | translate }}
      </button>

      <button
        mat-raised-button
        color="primary"
        (click)="onSubmit()"
        [disabled]="((tab$ | async) === UserAction.ADD && selectedUsers.length === 0) || (isLoading$ | async) === true"
      >
        <glxy-button-loading-indicator [isLoading]="(isLoading$ | async) === true">
          <ng-container *ngIf="(tab$ | async) === UserAction.ADD; else createButtonText">
            {{ 'ADD_USER_DIALOG.ADD_USERS' | translate }}
          </ng-container>
          <ng-template #createButtonText>
            {{ 'ADD_USER_DIALOG.CREATE_USER' | translate }}
          </ng-template>
        </glxy-button-loading-indicator>
      </button>
    </div>
  </mat-dialog-actions>
</ng-container>

<ng-template #brandViewActions>
  <mat-dialog-actions>
    <button mat-button color="primary" (click)="dialogRef.close(addedUsers)">
      {{ 'COMMON.ACTION_LABELS.CLOSE' | translate }}
    </button>
    <ng-container *ngIf="!showCreateTab">
      <button mat-raised-button color="primary" (click)="dialogRef.close('create-new-user')">
        {{ 'ADD_USER_DIALOG.CREATE_NEW_USER' | translate }}
      </button>
    </ng-container>
  </mat-dialog-actions>
</ng-template>
